// extracted by mini-css-extract-plugin
module.exports = {"container":"df5dab2e92--container--Ns9dw","icon":"df5dab2e92--icon--TfWWi"};